
import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useForm } from 'react-hook-form';
import * as yup from "yup";
import { organisationService } from '../../../../services/organisation.service';
import { Toast } from '../../../../utils/Toast';
import { IApiErrorPayload, isTwoFactorRequired } from '../../constants/auth-error.constants';
import { twoFactorService } from '../../../../services/two-factor.service';
import TwoFactorModal from '../../components/TwoFactorModal';
import {useTranslation} from "react-i18next";

const followRequestSchema = yup.object().shape({
    comment: yup.string()
}).required();

export const SendFollowRequestModal: React.FC<any> = (props) => {

    const [isLoading, setIsloading] = useState(false);
    const [challenge, setChallenge] = useState<IApiErrorPayload | null>(null);
    // Held so the request can be replayed verbatim after the code is redeemed.
    const [comment, setComment] = useState<string | undefined>();
    const { t } = useTranslation('', { keyPrefix: 'SendFollowRequestModal' });

    const { register, handleSubmit, formState: { errors }, setValue } = useForm<any>({
        resolver: yupResolver(followRequestSchema)
    });

    useEffect(() => {
        if (props.isEdit) {
            setValue('comment', props.selectedComment)
        }
    }, [])

    const handleCloseeight = () => {
        props.closeModal(false)
    }

    /**
     * Organizations with 2FA on answer the first attempt with a challenge
     * instead of creating the membership. The code is redeemed for a one-shot
     * verificationToken, and the same request is replayed carrying it.
     */
    const sendFollowRequest = async (comment?: string, verificationToken?: string) => {
        const res: any = await organisationService.followOrganizationRequest({
            organization: props.id,
            comment,
            ...(verificationToken ? { verificationToken } : {}),
        })
        if (res.statusCode == 201) {
            Toast.fire({
                icon: 'success',
                title: res.message
            })
            props.closeModal(res.payload.member)
        } else {
            Toast.fire({
                icon: 'warning',
                title: res.message
            })
        }
    }

    const followRequestSubmit = async (data: any) => {
        setIsloading(true)
        setComment(data.comment)
        try {
            await sendFollowRequest(data.comment)
        } catch (error: any) {
            // Previously absent: a 4xx threw straight out of this handler, so
            // the error branch above was dead code and nothing was shown.
            const payload = error?.response?.data ?? {}
            if (isTwoFactorRequired(payload)) {
                setChallenge(payload)
            } else {
                Toast.fire({
                    icon: 'warning',
                    title: payload.message || 'Could not send your request. Please try again.'
                })
            }
        } finally {
            setIsloading(false)
        }
    }

    const completeTwoFactor = async (challengeToken: string, otpCode: string) => {
        const res: any = await twoFactorService.verify({ challengeToken, otpCode })
        setChallenge(null)
        await sendFollowRequest(comment, res.payload.verificationToken)
    }

    if (challenge) {
        return <Modal className="up-thememodal" show={true} onHide={handleCloseeight}>
            <Modal.Body className="up-modalbody">
                <TwoFactorModal
                    challenge={challenge}
                    onVerified={completeTwoFactor}
                    onCancel={() => setChallenge(null)}
                />
            </Modal.Body>
        </Modal>
    }

    return <Modal className="up-thememodal up-modalcreategroup up-modalcreateevents" show={true} onHide={handleCloseeight}>
        <Modal.Body className="up-modalbody">
            <div className="up-modalcontentholder">
                <form className="up-formtheme up-formcreateevent" onSubmit={handleSubmit(followRequestSubmit)}>
                    <fieldset>
                        <div className="form-group">
                            <label>{props.isEdit ? t('viewKey') : t('yourAssignment')}</label>
                            <input disabled={props.isEdit} {...register("comment")} type="text" name="comment" className="form-control" placeholder={t('placeholder')} />
                            <small id="content" className="form-text text-muted">
                                {errors.comment?.message}
                            </small>
                        </div>
                        {!props.isEdit && <button disabled={isLoading} type="submit" className="up-btn">{t('sendFollowRequest')} {isLoading && <div className="lds-dual-ring"></div>}</button>}
                    </fieldset>
                </form>
            </div>
        </Modal.Body>
    </Modal>
}